// CompSelection is responsible for rendering the grid and details, and
// coordinating the current focused row selection.
import { Block, Flex } from '@aloft/toolkit-sui';
import { Table } from '@tanstack/react-table';

import { useRef, useState } from 'react';

import { CompSelectionProperty, CompSelectionProps } from '../types.ts';
import { CompSelectionDetails } from './CompSelectionDetails.tsx';
import { CompSelectionGrid } from './CompSelectionGrid.tsx';

export const CompSelection = ({
  sorting,
  setSorting,
  rowSelection,
  setRowSelection,
  data,
  subject,
  comps,
  source,
  orderID,
  isInspectifyOrder,
  hasArvOption,
  compSelectionTableVariant = 'sales',
}: CompSelectionProps) => {
  const compSelectionTableRef = useRef<Table<CompSelectionProperty> | undefined>();
  const [focusedRow, setFocusedRow] = useState<string | undefined>('subject');

  const dataWithPinned = [subject, ...data];
  const focusedPropertyIndex = dataWithPinned.findIndex((property) => property.id === focusedRow);
  const focusedProperty =
    focusedPropertyIndex !== -1 ? dataWithPinned[focusedPropertyIndex] : undefined;

  return (
    <Flex
      flexDirection="row"
      justifyContent="space-between"
      borderWidth="1px"
      borderColor="strokeDefault"
      borderStyle="solid"
      height="100%"
    >
      <Block width="100%" height="100%" overflowY="scroll">
        <CompSelectionGrid
          ref={compSelectionTableRef}
          data={data}
          subject={subject}
          comps={comps}
          sorting={sorting}
          setSorting={setSorting}
          rowSelection={rowSelection}
          setRowSelection={setRowSelection}
          setFocusedRow={setFocusedRow}
          focusedPropertyIndex={focusedPropertyIndex}
          source={source}
          orderID={orderID}
          isInspectifyOrder={isInspectifyOrder}
          hasArvOption={hasArvOption}
          compSelectionTableVariant={compSelectionTableVariant}
        />
      </Block>
      <Block flexShrink={0} width="30rem" backgroundColor="selected4">
        <CompSelectionDetails
          orderID={orderID}
          property={focusedProperty}
          setFocusedRow={setFocusedRow}
          subject={subject}
          data={data}
          comps={comps}
          compSelectionTableRef={compSelectionTableRef}
          sorting={sorting}
          rowSelection={rowSelection}
          isInspectifyOrder={isInspectifyOrder}
          hasArvOption={hasArvOption}
          compSelectionTableVariant={compSelectionTableVariant}
        />
      </Block>
    </Flex>
  );
};
